<template>
  <div>
    <a-modal v-model:visible="visible" title="新建预约" @ok="handleOk" okText="新建" cancelText="取消" :afterClose="closeModal">
      <a-form :model="formState" :label-col="labelCol" :wrapper-col="wrapperCol">

        <a-form-item label="门店">
          <a-select v-model:value="data.clubId" @change="changeClub">
            <a-select-option v-for="item in clubList" :value="item.clubId">{{ item.clubName }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="客户">
          <div class="flex">
            <a-select v-model:value="data.customerId" show-search :filterOption="filterName" @search="handleSearch" placeholder="请输入客户姓名搜索" allowClear>
              <a-select-option v-for="item in customerList" :value="item.id">{{ item.name }}</a-select-option>
            </a-select>
            <a-button @click="visible2=true">新增客户</a-button>
          </div>
        </a-form-item>

        <a-form-item label="日期">
          <a-date-picker v-model:value="data.date" :disabledDate="disabledDate" placeholder="" />
        </a-form-item>
        <a-form-item label="时段">
          <a-select v-model:value="data.period">
            <a-select-option v-for="item in periodList" :value="item">{{ item }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="医生">
          <a-select v-model:value="data.doctorId">
            <a-select-option v-for="item in employeeList" :value="item.id">{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
  <addCustomer v-model="visible2" @selectCustomer="selectCustomer" />
</template>

<script>
import { reactive } from "vue";
import { GetPeriod, EmployeeList, CustomerList, addAppointment } from "/src/api/businessManage/appointment.js";
import addCustomer from '/src/components/todayConsultation/addCustomer.vue';
import { pinyin } from 'pinyin-pro';
import { debounce } from 'lodash-es'
export default {
  components: {
    addCustomer
  },
  data() {
    return {
      visible: this.modelValue,
      visible2: false,
      medicineFilter: "",
      employeeList: [],
      data: {
        clubId: this.clubId,
        date: this.date,
        period: undefined,
        doctorId: undefined,
        customerId: undefined,
      },
      periodList: [],
      searchTimer: null, // 存储定时器
      customerList: [],
      editableData: reactive({}),
      selectedRows: {},
      labelCol: {
        span: 6,
      },
      disabledDate: undefined,
      wrapperCol: {
        span: 14,
      },
      editableData: reactive({}),
    };
  },
  emits: ['update:modelValue'],
  created() {
  },
  mounted() {
    this.init()
  },
  activated() {
  },
  //获取父元素传值
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    clubList: {
      type: Array,
      default: () => [],
    },
    clubId: {
      type: String,
      default: undefined,
    },
  },
  computed: {
    medicineList() {
      const list = this.$store.state.medicineList;
      if (!this.medicineFilter) {
        return list.slice(0, 200);
      }
      return list.filter(item => item.name?.toLowerCase().includes(this.medicineFilter) || item.nameInitial?.toLowerCase().includes(this.medicineFilter)).slice(0, 200);
    }
  },
  methods: {
    init() {
    },
    filterName(input, option) {
      return (
        option.children[0].children.toLowerCase().indexOf(input.toLowerCase()) >=
        0
      );
    },
    async handleSearch(value) {
      // 侯明毅
      // 清除上一次的定时器
      if (this.searchTimer) {
        clearTimeout(this.searchTimer)
      }
      // 设置新的定时器
      this.searchTimer = setTimeout(async () => {
        if (value && value.length >= 2) {
          try {
            let res = await CustomerList({
              name: value,
            })
            console.log('搜索结果:', res.data)
            this.customerList = res.data
          } catch (error) {
            console.error('搜索失败:', error)
            this.customerList = []
          }
        } else {
          this.customerList = []
        }
      }, 1000)
    },
    filter() {
      return true
    },
    async onDelete(id) {
      this.editableData = {}
      let res = await Delete({ id })
      if (res.errCode == 0) {
        this.data = this.data.filter(function (item) {
          return item.id !== id;
        });
      }
    },
    async handleOk() {
      let _this = this;
      //名字不能为空
      if (!this.data.clubId) {
        this.$message.error("请选择门店", function () { });
        return
      }
      if (!this.data.customerId) {
        this.$message.error("请选择客户", function () { });
        return
      }
      if (!this.data.date) {
        this.$message.error("请选择日期", function () { });
        return
      }
      if (!this.data.period) {
        this.$message.error("请选择时段", function () { });
        return
      }
      if (!this.data.doctorId) {
        this.$message.error("请选择医生", function () { });
        return
      }
      let res = await addAppointment(this.data)
      if (res.errCode == 0) {
        _this.$message.success("新建成功", function () { });
        _this.visible = false
        this.data = {
          name: undefined,
          gender: undefined,
          nameInitial: undefined,
          isStandard: true,
        }
      }

    },
    closeModal() {
      this.$emit('update:modelValue', false);
    },
    getInitial(name) {
      let list = name.split("");
      let str = "";
      list.forEach(item => {
        str += pinyin(item, { toneType: 'none' }).split("")[0];
      });
      return str
    },
    changeNameInitial() {
      this.data.nameInitial = this.getInitial(this.data.name)
    },
    async changeClub() {
      let res = await GetPeriod({ clubId: this.data.clubId });
      this.periodList = res.data || []

      let res2 = await EmployeeList({ clubId: this.data.clubId, position: "医生" });
      console.log(res2);

      this.employeeList = res2.data || []

      // let res3 = await CustomerList({ clubId: this.data.clubId });
      // this.customerList = res3.data.records || []
      // 侯明毅
    },
    selectCustomer(value) {
      // 1. 确保 customerList 中包含这个新客户（否则 select 无法显示）
      const exists = this.customerList.some(item => item.id === value.id);
      if (!exists) {
        // 添加到 customerList 开头（或末尾）
        this.customerList.unshift({
          id: value.id,
          name: value.name
        });
      }

      // 2. 设置选中值
      this.data.customerId = value.id;
    }

  },
  watch: {
    modelValue(val) {
      this.visible = val
    },
    clubId(val) {
      this.data.clubId = val
      this.changeClub()
    },
  }
};
</script>

<style scoped>
.head {
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
  align-items: center;
}
.head span {
  font-weight: bold;
  margin-right: 10px;
}
.flex {
  display: flex;
  gap: 10px;
  align-items: center;
}
</style>
